<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Detailed statistics</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-8">
        <app-date-range-selector [date]="initialPeriod.preset" [initialFrom]="initialPeriod.from"
          [initialTo]="initialPeriod.to" [zone]="'Europe/Paris'"></app-date-range-selector>
      </div>

      <div class="col-4">
        <label for="showTransactions" class="form-label fw-bold small">Show Transactions</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-file-earmark-text"></i></span>
          <select id="showTransactions" class="form-select" [(ngModel)]="filters.transactionDate">
            @for (transactionDate of transactionDates; track transactionDate.value) {
              <option [ngValue]="transactionDate.value">{{ transactionDate.label }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <app-stats-filters [initialParams]="initialParams" (ready)="filter()">
      <div class="col-3">
        <label for="groupBy" class="form-label fw-bold small">Group By</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-diagram-2"></i></span>
          <select id="groupBy" class="form-select" [(ngModel)]="filters.groupBy">
            @for (option of groupByOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
          </select>
        </div>
      </div>
    </app-stats-filters>

    <div class="row mb-3">
      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-3">
            <!--                        <label class="form-label fw-bold small">Preconfigured Reports</label>-->
            <!--                        <div class="input-group">-->
            <!--                            <span class="input-group-text"><i class="bi bi-save"></i></span>-->
            <!--                            <select class="form-select">-->
            <!--                                <option>Pre</option>-->
          <!--                            </select>-->
          <!--                            <button type="button" class="btn btn-outline-primary fw-bold">Edit</button>-->
          <!--                            <button type="button" class="btn btn-outline-primary fw-bold" data-bs-toggle="modal"-->
          <!--                                    data-bs-target="#saveReportModal">Save-->
        <!--                            </button>-->
        <!--                            <button type="button" class="btn btn-primary fw-bold">Apply</button>-->
      <!--                        </div>-->
    </div>

    <div class="col-9 mt-4 text-end d-flex align-items-end justify-content-end">
      <button type="button" class="btn btn-outline-primary me-2" (click)="saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary me-2" (click)="clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
      <button type="button" class="btn btn-outline-primary fw-bold me-2" [disabled]="loading || !rows.length"
        (click)="downloadCsv()"><i
      class="bi bi-file-earmark-spreadsheet"></i> Export to CSV
    </button>
    <button type="submit" class="btn btn-primary fw-bold" (click)="filter()">Apply filters</button>
  </div>
</div>
</div>
</div>
</div>
</div>

@if (!loading) {
  <div class="card border-0 shadow mb-3">
    <div class="card-header fw-bold bg-tertiary p-3 border-0">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-file-earmark-spreadsheet me-2"></i>Details statistics table</h2>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover table-striped align-middle" [(appSortableTable)]="rows">
          <thead class="thead-light">
            <tr>
              <th class="date-stats-column" appSortable="label" sortType="string">{{ getGroupByColumnName() }}</th>
              @if (isGroupedByLandingPage()) {
                <th class="lp-link-column"></th>
                <th class="lp-link-column"></th>
              }
              <th class="header-clicks-group" appSortable="clicks" sortType="number">Clicks</th>
              <th class="header-clicks-group" appSortable="cost" sortType="number">Cost</th>
              <th class="header-clicks-group" appSortable="cpc" sortType="number">EPC / CPC</th>
              <th class="header-clicks-group" appSortable="cpl" sortType="number">CPL</th>
              <th [colSpan]="moreDetails.lead ? 15 : 3" class="lead-header"
                (click)="moreDetails.lead =! moreDetails.lead">
                LEAD {{ moreDetails.lead ? '-' : '+' }}
              </th>
              @if (hasGoalType('first')) {
                <th [colSpan]="moreDetails.firstProposal ? 7 : 2" class="first-proposal-header"
                  (click)="moreDetails.firstProposal =! moreDetails.firstProposal">
                  FIRST {{ moreDetails.firstProposal ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('e-shop')) {
                <th [colSpan]="moreDetails.eShop ? 7 : 2" class="e-shop-header"
                  (click)="moreDetails.eShop =! moreDetails.eShop">
                  E-SHOP {{ moreDetails.eShop ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('strategy')) {
                <th [colSpan]="moreDetails.strategy ? 7 : 2" class="strat-header"
                  (click)="moreDetails.strategy =! moreDetails.strategy">
                  STRAT {{ moreDetails.strategy ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('doubleanim')) {
                <th [colSpan]="moreDetails.doubleAnim ? 7 : 2" class="double-animation-header"
                  (click)="moreDetails.doubleAnim =! moreDetails.doubleAnim">
                  DOUBLE ANIMATION {{ moreDetails.doubleAnim ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('auto')) {
                <th [colSpan]="moreDetails.auto ? 7 : 2" class="fid-auto-header"
                  (click)="moreDetails.auto =! moreDetails.auto">
                  FID AUTO {{ moreDetails.auto ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('loyalty')) {
                <th [colSpan]="moreDetails.loyalty ? 7 : 2" class="fid-manuelle-header"
                  (click)="moreDetails.loyalty =! moreDetails.loyalty">
                  FID MANUELLE {{ moreDetails.loyalty ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('opar')) {
                <th [colSpan]="moreDetails.opar ? 7 : 2" class="opar-header"
                  (click)="moreDetails.opar =! moreDetails.opar"
                  >
                  OPAR {{ moreDetails.opar ? '-' : '+' }}
                </th>
              }
              @if (hasGoalType('misc')) {
                <th [colSpan]="moreDetails.misc ? 7 : 2" class="misc-header"
                  (click)="moreDetails.misc =! moreDetails.misc"
                  >
                  MISC {{ moreDetails.misc ? '-' : '+' }}
                </th>
              }
              <th [colSpan]="moreDetails.total ? 7 : 2" class="total-header"
                (click)="moreDetails.total =! moreDetails.total">
                TOTAL {{ moreDetails.total ? '-' : '+' }}
              </th>
            </tr>
            <tr>
              <th></th>
              @if (isGroupedByLandingPage()) {
                <th></th>
                <th></th>
              }
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th class="lead-table lead-row" appSortable="leadOk" sortType="number">OK</th>
              <th class="lead-table lead-row" appSortable="leadOkPercent" sortType="number">OK (%)</th>
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadKo" sortType="number">KO</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadAR" sortType="number">AR</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadARPercent" sortType="number">AR (%)</th>
              }
              <th class="lead-table lead-row" appSortable="leadDoi" sortType="number">DOI</th>
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadDoiPercent" sortType="number">DOI (%)</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadP0" sortType="number">P0</th>
                <th class="lead-table lead-row" appSortable="leadP0Percent" sortType="number">P0 (%)</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCoregOk" sortType="number">P2</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCoregOkPercent" sortType="number">P2 (%)</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCoregAAOk" sortType="number">AA</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCoregAAOkPercent" sortType="number">AA (%)</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCrossOk" sortType="number">Xsell</th>
              }
              @if (moreDetails.lead) {
                <th class="lead-table lead-row" appSortable="leadCrossOkPercent" sortType="number">Xsell (%)</th>
              }
              @if (hasGoalType('first')) {
                @if (moreDetails.firstProposal) {
                  <th class="first-proposal first-proposal-row" appSortable="goals.checkout.first.count" sortType="number">Checkout</th>
                }
                <th class="first-proposal first-proposal-row" appSortable="goals.sale.first.count" sortType="number">Sales</th>
                <th class="first-proposal first-proposal-row" appSortable="goals.sale.first.amount" sortType="number">Turnover</th>
                @if (moreDetails.firstProposal) {
                  <th class="first-proposal first-proposal-row">Subscription
                  </th>
                }
                @if (moreDetails.firstProposal) {
                  <th class="first-proposal first-proposal-row">Renewal</th>
                }
                @if (moreDetails.firstProposal) {
                  <th class="first-proposal first-proposal-row">Refund</th>
                }
                @if (moreDetails.firstProposal) {
                  <th class="first-proposal first-proposal-row">Chargeback</th>
                }
              }
              @if (hasGoalType('e-shop')) {
                @if (moreDetails.eShop) {
                  <th class="e-shop e-shop-row" appSortable="goals.checkout.e-shop.count" sortType="number">Checkout</th>
                }
                <th class="e-shop e-shop-row" appSortable="goals.sale.e-shop.count" sortType="number">Sales</th>
                <th class="e-shop e-shop-row" appSortable="goals.sale.e-shop.amount" sortType="number">Turnover</th>
                @if (moreDetails.eShop) {
                  <th class="e-shop e-shop-row">Subscription
                  </th>
                }
                @if (moreDetails.eShop) {
                  <th class="e-shop e-shop-row">Renewal</th>
                }
                @if (moreDetails.eShop) {
                  <th class="e-shop e-shop-row">Refund</th>
                }
                @if (moreDetails.eShop) {
                  <th class="e-shop e-shop-row">Chargeback</th>
                }
              }
              @if (hasGoalType('strategy')) {
                @if (moreDetails.strategy) {
                  <th class="strat strat-row" appSortable="goals.checkout.strategy.count" sortType="number">Checkout</th>
                }
                <th class="strat strat-row" appSortable="goals.sale.strategy.count" sortType="number">Sales</th>
                <th class="strat strat-row" appSortable="goals.sale.strategy.amount" sortType="number">Turnover</th>
                @if (moreDetails.strategy) {
                  <th class="strat strat-row">Subscription</th>
                }
                @if (moreDetails.strategy) {
                  <th class="strat strat-row">Renewal</th>
                }
                @if (moreDetails.strategy) {
                  <th class="strat strat-row">Refund</th>
                }
                @if (moreDetails.strategy) {
                  <th class="strat strat-row">Chargeback</th>
                }
              }
              @if (hasGoalType('doubleanim')) {
                @if (moreDetails.doubleAnim) {
                  <th class="double-animation double-animation-row" appSortable="goals.checkout.doubleanim.count" sortType="number">Checkout</th>
                }
                <th class="double-animation double-animation-row" appSortable="goals.sale.doubleanim.count" sortType="number">Sales</th>
                <th class="double-animation double-animation-row" appSortable="goals.sale.doubleanim.amount" sortType="number">Turnover</th>
                @if (moreDetails.doubleAnim) {
                  <th class="double-animation double-animation-row">Subscription
                  </th>
                }
                @if (moreDetails.doubleAnim) {
                  <th class="double-animation double-animation-row">Renewal</th>
                }
                @if (moreDetails.doubleAnim) {
                  <th class="double-animation double-animation-row">Refund</th>
                }
                @if (moreDetails.doubleAnim) {
                  <th class="double-animation double-animation-row">Chargeback</th>
                }
              }
              @if (hasGoalType('auto')) {
                @if (moreDetails.auto) {
                  <th class="fid-auto fid-auto-row" appSortable="goals.checkout.auto.count" sortType="number">Checkout</th>
                }
                <th class="fid-auto fid-auto-row" appSortable="goals.sale.auto.count" sortType="number">Sales</th>
                <th class="fid-auto fid-auto-row" appSortable="goals.sale.auto.amount" sortType="number">Turnover</th>
                @if (moreDetails.auto) {
                  <th class="fid-auto fid-auto-row">Subscription</th>
                }
                @if (moreDetails.auto) {
                  <th class="fid-auto fid-auto-row">Renewal</th>
                }
                @if (moreDetails.auto) {
                  <th class="fid-auto fid-auto-row">Refund</th>
                }
                @if (moreDetails.auto) {
                  <th class="fid-auto fid-auto-row">Chargeback</th>
                }
              }
              @if (hasGoalType('loyalty')) {
                @if (moreDetails.loyalty) {
                  <th class="fid-manuelle fid-manuelle-row" appSortable="goals.checkout.loyalty.count" sortType="number">Checkout</th>
                }
                <th class="fid-manuelle fid-manuelle-row" appSortable="goals.sale.loyalty.count" sortType="number">Sales</th>
                <th class="fid-manuelle fid-manuelle-row" appSortable="goals.sale.loyalty.amount" sortType="number">Turnover</th>
                @if (moreDetails.loyalty) {
                  <th class="fid-manuelle fid-manuelle-row">Subscription</th>
                }
                @if (moreDetails.loyalty) {
                  <th class="fid-manuelle fid-manuelle-row">Renewal</th>
                }
                @if (moreDetails.loyalty) {
                  <th class="fid-manuelle fid-manuelle-row">Refund</th>
                }
                @if (moreDetails.loyalty) {
                  <th class="fid-manuelle fid-manuelle-row">Chargeback</th>
                }
              }
              @if (hasGoalType('opar')) {
                @if (moreDetails.opar) {
                  <th class="opar opar-row" appSortable="goals.checkout.opar.count" sortType="number">Checkout</th>
                }
                <th class="opar opar-row" appSortable="goals.sale.opar.count" sortType="number">Sales</th>
                <th class="opar opar-row" appSortable="goals.sale.opar.amount" sortType="number">Turnover</th>
                @if (moreDetails.opar) {
                  <th class="opar opar-row">Subscription</th>
                }
                @if (moreDetails.opar) {
                  <th class="opar opar-row">Renewal</th>
                }
                @if (moreDetails.opar) {
                  <th class="opar opar-row">Refund</th>
                }
                @if (moreDetails.opar) {
                  <th class="opar opar-row">Chargeback</th>
                }
              }
              @if (hasGoalType('misc')) {
                @if (moreDetails.misc) {
                  <th class="misc misc-row" appSortable="goals.checkout.misc.count" sortType="number">Checkout</th>
                }
                <th class="misc misc-row" appSortable="goals.sale.misc.count" sortType="number">Sales</th>
                <th class="misc misc-row" appSortable="goals.sale.misc.amount" sortType="number">Turnover</th>
                @if (moreDetails.misc) {
                  <th class="misc misc-row">Subscription</th>
                }
                @if (moreDetails.misc) {
                  <th class="misc misc-row">Renewal</th>
                }
                @if (moreDetails.misc) {
                  <th class="misc misc-row">Refund</th>
                }
                @if (moreDetails.misc) {
                  <th class="misc misc-row">Chargeback</th>
                }
              }
              @if (moreDetails.total) {
                <th class="total total-row" appSortable="goals.checkout.totals.count" sortType="number">Checkout</th>
              }
              <th class="total total-row" appSortable="goals.sale.totals.count" sortType="number">Sales</th>
              <th class="total total-row" appSortable="goals.sale.totals.amount" sortType="number">Turnover</th>
              @if (moreDetails.total) {
                <th class="total total-row">Subscription</th>
              }
              @if (moreDetails.total) {
                <th class="total total-row">Renewal</th>
              }
              @if (moreDetails.total) {
                <th class="total total-row">Refund</th>
              }
              @if (moreDetails.total) {
                <th class="total total-row">Chargeback</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row) {
              <tr>
                <td class="fw-bold">
                  {{ getLabel(row) }}
                  @if (isGroupedByDay()) {
                    <a class="hourly-link ms-1" [routerLink]="['/stats/hourly']" [queryParams]="getHourlyQueryParams(row)"
                      title="Hour by hour statistics of this day"><i class="bi bi-clock"></i></a>
                  }
                </td>
                @if (isGroupedByLandingPage()) {
                  <td class="lp-link-column">
                    @if (row.landingPage?.url) {
                      <a [href]="row.landingPage.url" target="_blank" rel="noopener" [title]="row.landingPage.url">
                        <i class="bi bi-box-arrow-up-right"></i>
                      </a>
                    }
                  </td>
                  <td class="lp-link-column">
                    @if (getLandingPageEditLink(row); as editLink) {
                      <a [routerLink]="editLink.route" target="_blank" [title]="editLink.title">
                        <i class="bi bi-pencil-square"></i>
                      </a>
                    }
                  </td>
                }
                <td>{{ row.clicks }}</td>
                <td [ngClass]="{novalue:!hasCost()}">{{ row.cost | money }}</td>
                <td [ngClass]="{novalue:!hasCost()}">{{ row.cpc | money }}</td>
                <td [ngClass]="{novalue:!hasCost()}">{{ row.cpl | money }}</td>
                <td class="lead-table lead-row">{{ row.leadOk }}</td>
                <td class="lead-table lead-row">{{ row.leadOkPercent | percent:2:'-' }}</td>
                @if (moreDetails.lead) {
                  <td class="lead-table lead-row">{{ row.leadKo }}</td>
                }
                @if (moreDetails.lead) {
                  <td class="lead-table lead-row"><span class="tt"
                  [appTooltip]="getARTooltip(row)">{{ row.leadAR }}</span>
                </td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadARPercent | percent:2:'-' }}</td>
              }
              <td class="lead-table lead-row">{{ row.leadDoi }}</td>
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadDoiPercent | percent:2:'-' }}</td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadP0 }}</td>
                <td class="lead-table lead-row">{{ row.leadP0Percent | percent:2:'-' }}</td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadCoregOk }}</td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row"
                  >{{ row.leadCoregOkPercent | percent:2:'-' }}
                </td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadCoregAAOk }}</td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row"
                  >{{ row.leadCoregAAOkPercent | percent:2:'-' }}
                </td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row">{{ row.leadCrossOk }}</td>
              }
              @if (moreDetails.lead) {
                <td class="lead-table lead-row"
                  >{{ row.leadCrossOkPercent | percent:2:'-' }}
                </td>
              }
              <!--          <td class="lead-table lead-row" *ngIf="moreDetails.lead"></td>-->
              <!--          <td class="lead-table lead-row" *ngIf="moreDetails.lead"></td>-->
              @if (hasGoalType('first')) {
                @if (moreDetails.firstProposal) {
                  <td class="first-proposal first-proposal-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'first')">
                      {{ getCheckouts(row, 'first') }}
                    </a>
                  </td>
                }
                <td class="first-proposal first-proposal-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'first')">
                    {{ getSales(row, 'first') }}
                  </a>
                </td>
                <td class="first-proposal first-proposal-row">{{ getTurnover(row, 'first') | money }}</td>
                @if (moreDetails.firstProposal) {
                  <td class="first-proposal first-proposal-row"
                    >{{ getSubscriptions(row, 'first') }}
                  </td>
                }
                @if (moreDetails.firstProposal) {
                  <td class="first-proposal first-proposal-row"
                    >{{ getRenewals(row, 'first') }}
                  </td>
                }
                @if (moreDetails.firstProposal) {
                  <td class="first-proposal first-proposal-row"
                    >{{ getRefunds(row, 'first') }}
                  </td>
                }
                @if (moreDetails.firstProposal) {
                  <td class="first-proposal first-proposal-row"
                    >{{ getChargebacks(row, 'first') }}
                  </td>
                }
              }
              @if (hasGoalType('e-shop')) {
                @if (moreDetails.eShop) {
                  <td class="e-shop e-shop-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'e-shop')">
                      {{ getCheckouts(row, 'e-shop') }}
                    </a>
                  </td>
                }
                <td class="e-shop e-shop-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'e-shop')">
                    {{ getSales(row, 'e-shop') }}
                  </a>
                </td>
                <td class="e-shop e-shop-row">{{ getTurnover(row, 'e-shop') | money }}</td>
                @if (moreDetails.eShop) {
                  <td class="e-shop e-shop-row"
                    >{{ getSubscriptions(row, 'e-shop') }}
                  </td>
                }
                @if (moreDetails.eShop) {
                  <td class="e-shop e-shop-row"
                    >{{ getRenewals(row, 'e-shop') }}
                  </td>
                }
                @if (moreDetails.eShop) {
                  <td class="e-shop e-shop-row"
                    >{{ getRefunds(row, 'e-shop') }}
                  </td>
                }
                @if (moreDetails.eShop) {
                  <td class="e-shop e-shop-row"
                    >{{ getChargebacks(row, 'e-shop') }}
                  </td>
                }
              }
              @if (hasGoalType('strategy')) {
                @if (moreDetails.strategy) {
                  <td class="strat strat-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'strategy')">
                      {{ getCheckouts(row, 'strategy') }}
                    </a>
                  </td>
                }
                <td class="strat strat-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'strategy')">
                    {{ getSales(row, 'strategy') }}
                  </a>
                </td>
                <td class="strat strat-row">{{ getTurnover(row, 'strategy') | money }}</td>
                @if (moreDetails.strategy) {
                  <td class="strat strat-row"
                    >{{ getSubscriptions(row, 'strategy') }}
                  </td>
                }
                @if (moreDetails.strategy) {
                  <td class="strat strat-row">{{ getRenewals(row, 'strategy') }}</td>
                }
                @if (moreDetails.strategy) {
                  <td class="strat strat-row">{{ getRefunds(row, 'strategy') }}</td>
                }
                @if (moreDetails.strategy) {
                  <td class="strat strat-row">{{ getChargebacks(row, 'strategy') }}
                  </td>
                }
              }
              @if (hasGoalType('doubleanim')) {
                @if (moreDetails.doubleAnim) {
                  <td class="double-animation double-animation-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'doubleanim')">
                      {{ getCheckouts(row, 'doubleanim') }}
                    </a>
                  </td>
                }
                <td class="double-animation double-animation-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'doubleanim')">
                    {{ getSales(row, 'doubleanim') }}
                  </a>
                </td>
                <td class="double-animation double-animation-row">{{ getTurnover(row, 'doubleanim') | money }}</td>
                @if (moreDetails.doubleAnim) {
                  <td class="double-animation double-animation-row"
                    >{{ getSubscriptions(row, 'doubleanim') }}
                  </td>
                }
                @if (moreDetails.doubleAnim) {
                  <td class="double-animation double-animation-row"
                    >{{ getRenewals(row, 'doubleanim') }}
                  </td>
                }
                @if (moreDetails.doubleAnim) {
                  <td class="double-animation double-animation-row"
                    >{{ getRefunds(row, 'doubleanim') }}
                  </td>
                }
                @if (moreDetails.doubleAnim) {
                  <td class="double-animation double-animation-row"
                    >{{ getChargebacks(row, 'doubleanim') }}
                  </td>
                }
              }
              @if (hasGoalType('auto')) {
                @if (moreDetails.auto) {
                  <td class="fid-auto fid-auto-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'auto')">
                      {{ getCheckouts(row, 'auto') }}
                    </a>
                  </td>
                }
                <td class="fid-auto fid-auto-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'auto')">
                    {{ getSales(row, 'auto') }}
                  </a>
                </td>
                <td class="fid-auto fid-auto-row">{{ getTurnover(row, 'auto') | money }}</td>
                @if (moreDetails.auto) {
                  <td class="fid-auto fid-auto-row">{{ getSubscriptions(row, 'auto') }}
                  </td>
                }
                @if (moreDetails.auto) {
                  <td class="fid-auto fid-auto-row">{{ getRenewals(row, 'auto') }}</td>
                }
                @if (moreDetails.auto) {
                  <td class="fid-auto fid-auto-row">{{ getRefunds(row, 'auto') }}</td>
                }
                @if (moreDetails.auto) {
                  <td class="fid-auto fid-auto-row">{{ getChargebacks(row, 'auto') }}
                  </td>
                }
              }
              @if (hasGoalType('loyalty')) {
                @if (moreDetails.loyalty) {
                  <td class="fid-manuelle fid-manuelle-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'loyalty')">
                      {{ getCheckouts(row, 'loyalty') }}
                    </a>
                  </td>
                }
                <td class="fid-manuelle fid-manuelle-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'loyalty')">
                    {{ getSales(row, 'loyalty') }}
                  </a>
                </td>
                <td class="fid-manuelle fid-manuelle-row">{{ getTurnover(row, 'loyalty') | money }}</td>
                @if (moreDetails.loyalty) {
                  <td class="fid-manuelle fid-manuelle-row"
                    >{{ getSubscriptions(row, 'loyalty') }}
                  </td>
                }
                @if (moreDetails.loyalty) {
                  <td class="fid-manuelle fid-manuelle-row"
                    >{{ getRenewals(row, 'loyalty') }}
                  </td>
                }
                @if (moreDetails.loyalty) {
                  <td class="fid-manuelle fid-manuelle-row"
                    >{{ getRefunds(row, 'loyalty') }}
                  </td>
                }
                @if (moreDetails.loyalty) {
                  <td class="fid-manuelle fid-manuelle-row"
                    >{{ getChargebacks(row, 'loyalty') }}
                  </td>
                }
              }
              @if (hasGoalType('opar')) {
                @if (moreDetails.opar) {
                  <td class="opar opar-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'opar')">
                      {{ getCheckouts(row, 'opar') }}
                    </a>
                  </td>
                }
                <td class="opar opar-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'opar')">
                    {{ getSales(row, 'opar') }}
                  </a>
                </td>
                <td class="opar opar-row">{{ getTurnover(row, 'opar') | money }}</td>
                @if (moreDetails.opar) {
                  <td class="opar opar-row">{{ getSubscriptions(row, 'opar') }}</td>
                }
                @if (moreDetails.opar) {
                  <td class="opar opar-row">{{ getRenewals(row, 'opar') }}</td>
                }
                @if (moreDetails.opar) {
                  <td class="opar opar-row">{{ getRefunds(row, 'opar') }}</td>
                }
                @if (moreDetails.opar) {
                  <td class="opar opar-row">{{ getChargebacks(row, 'opar') }}</td>
                }
              }
              @if (hasGoalType('misc')) {
                @if (moreDetails.misc) {
                  <td class="misc misc-row">
                    <a class="transactions"
                      (click)="showTransactions(row, 'checkout', 'misc')">
                      {{ getCheckouts(row, 'misc') }}
                    </a>
                  </td>
                }
                <td class="misc misc-row">
                  <a class="transactions"
                    (click)="showTransactions(row, 'sale', 'misc')">
                    {{ getSales(row, 'misc') }}
                  </a>
                </td>
                <td class="misc misc-row">{{ getTurnover(row, 'misc') | money }}</td>
                @if (moreDetails.misc) {
                  <td class="misc misc-row">{{ getSubscriptions(row, 'misc') }}</td>
                }
                @if (moreDetails.misc) {
                  <td class="misc misc-row">{{ getRenewals(row, 'misc') }}</td>
                }
                @if (moreDetails.misc) {
                  <td class="misc misc-row">{{ getRefunds(row, 'misc') }}</td>
                }
                @if (moreDetails.misc) {
                  <td class="misc misc-row">{{ getChargebacks(row, 'misc') }}</td>
                }
              }
              @if (moreDetails.total) {
                <td class="total total-row"
                  >{{ getCheckouts(row, 'totals') }}
                </td>
              }
              <td class="total total-row">{{ getSales(row, 'totals') }}</td>
              <td class="total total-row">{{ getTurnover(row, 'totals') | money }}</td>
              @if (moreDetails.total) {
                <td class="total total-row">{{ getSubscriptions(row, 'totals') }}</td>
              }
              @if (moreDetails.total) {
                <td class="total total-row">{{ getRenewals(row, 'totals') }}</td>
              }
              @if (moreDetails.total) {
                <td class="total total-row">{{ getRefunds(row, 'totals') }}</td>
              }
              @if (moreDetails.total) {
                <td class="total total-row">{{ getChargebacks(row, 'totals') }}</td>
              }
            </tr>
          }
          <tr>
            <td class="fw-bold">Total</td>
            @if (isGroupedByLandingPage()) {
              <td></td>
              <td></td>
            }
            <td class="fw-bold">{{ totals.clicks }}</td>
            <td class="fw-bold" [ngClass]="{novalue:!hasCost()}">{{ totals.cost | money }}</td>
            <td class="fw-bold" [ngClass]="{novalue:!hasCost()}">{{ totals.cpc | money }}</td>
            <td class="fw-bold" [ngClass]="{novalue:!hasCost()}">{{ totals.cpl | money }}</td>
            <td class="lead-table lead-row fw-bold">{{ totals.leadOk }}</td>
            <td class="lead-table lead-row fw-bold">{{ totals.leadOkPercent | percent:2:'-' }}</td>
            @if (moreDetails.lead) {
              <td class="lead-table lead-row fw-bold">{{ totals.leadKo }}</td>
            }
            @if (moreDetails.lead) {
              <td class="lead-table lead-row fw-bold"><span class="tt"
              [appTooltip]="getARTooltip(totals)">{{ totals.leadAR }}</span>
            </td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold">{{ totals.leadARPercent | percent:2:'-' }}
            </td>
          }
          <td class="lead-table lead-row fw-bold">{{ totals.leadDoi }}</td>
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold"
              >{{ totals.leadDoiPercent | percent:2:'-' }}
            </td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold">{{ totals.leadP0 }}</td>
            <td class="lead-table lead-row fw-bold">{{ totals.leadP0Percent | percent:2:'-' }}</td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold">{{ totals.leadCoregOk }}</td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold"
              >{{ totals.leadCoregOkPercent | percent:2:'-' }}
            </td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold">{{ totals.leadCoregAAOk }}</td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold"
              >{{ totals.leadCoregAAOkPercent | percent:2:'-' }}
            </td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold">{{ totals.leadCrossOk }}</td>
          }
          @if (moreDetails.lead) {
            <td class="lead-table lead-row fw-bold"
              >{{ totals.leadCrossOkPercent | percent:2:'-' }}
            </td>
          }
          @if (hasGoalType('first')) {
            @if (moreDetails.firstProposal) {
              <td class="first-proposal first-proposal-row fw-bold"
                >{{ getCheckouts(totals, 'first') }}
              </td>
            }
            <td class="first-proposal first-proposal-row fw-bold">{{ getSales(totals, 'first') }}</td>
            <td class="first-proposal first-proposal-row fw-bold">{{ getTurnover(totals, 'first') | money }}</td>
            @if (moreDetails.firstProposal) {
              <td class="first-proposal first-proposal-row fw-bold"
                >{{ getSubscriptions(totals, 'first') }}
              </td>
            }
            @if (moreDetails.firstProposal) {
              <td class="first-proposal first-proposal-row fw-bold"
                >{{ getRenewals(totals, 'first') }}
              </td>
            }
            @if (moreDetails.firstProposal) {
              <td class="first-proposal first-proposal-row fw-bold"
                >{{ getRefunds(totals, 'first') }}
              </td>
            }
            @if (moreDetails.firstProposal) {
              <td class="first-proposal first-proposal-row fw-bold"
                >{{ getChargebacks(totals, 'first') }}
              </td>
            }
          }
          @if (hasGoalType('e-shop')) {
            @if (moreDetails.eShop) {
              <td class="e-shop e-shop-row fw-bold">{{ getCheckouts(totals, 'e-shop') }}</td>
            }
            <td class="e-shop e-shop-row fw-bold">{{ getSales(totals, 'e-shop') }}</td>
            <td class="e-shop e-shop-row fw-bold">{{ getTurnover(totals, 'e-shop') | money }}</td>
            @if (moreDetails.eShop) {
              <td class="e-shop e-shop-row fw-bold"
                >{{ getSubscriptions(totals, 'e-shop') }}
              </td>
            }
            @if (moreDetails.eShop) {
              <td class="e-shop e-shop-row fw-bold"
                >{{ getRenewals(totals, 'e-shop') }}
              </td>
            }
            @if (moreDetails.eShop) {
              <td class="e-shop e-shop-row fw-bold"
                >{{ getRefunds(totals, 'e-shop') }}
              </td>
            }
            @if (moreDetails.eShop) {
              <td class="e-shop e-shop-row fw-bold"
                >{{ getChargebacks(totals, 'e-shop') }}
              </td>
            }
          }
          @if (hasGoalType('strategy')) {
            @if (moreDetails.strategy) {
              <td class="strat strat-row fw-bold">{{ getCheckouts(totals, 'strategy') }}</td>
            }
            <td class="strat strat-row fw-bold">{{ getSales(totals, 'strategy') }}</td>
            <td class="strat strat-row fw-bold">{{ getTurnover(totals, 'strategy') | money }}</td>
            @if (moreDetails.strategy) {
              <td class="strat strat-row fw-bold"
                >{{ getSubscriptions(totals, 'strategy') }}
              </td>
            }
            @if (moreDetails.strategy) {
              <td class="strat strat-row fw-bold"
                >{{ getRenewals(totals, 'strategy') }}
              </td>
            }
            @if (moreDetails.strategy) {
              <td class="strat strat-row fw-bold"
                >{{ getRefunds(totals, 'strategy') }}
              </td>
            }
            @if (moreDetails.strategy) {
              <td class="strat strat-row fw-bold"
                >{{ getChargebacks(totals, 'strategy') }}
              </td>
            }
          }
          @if (hasGoalType('doubleanim')) {
            @if (moreDetails.doubleAnim) {
              <td class="double-animation double-animation-row fw-bold"
                >{{ getCheckouts(totals, 'doubleanim') }}
              </td>
            }
            <td class="double-animation double-animation-row fw-bold">{{ getSales(totals, 'doubleanim') }}</td>
            <td class="double-animation double-animation-row fw-bold">{{ getTurnover(totals, 'doubleanim') | money }}
            </td>
            @if (moreDetails.doubleAnim) {
              <td class="double-animation double-animation-row fw-bold"
                >{{ getSubscriptions(totals, 'doubleanim') }}
              </td>
            }
            @if (moreDetails.doubleAnim) {
              <td class="double-animation double-animation-row fw-bold"
                >{{ getRenewals(totals, 'doubleanim') }}
              </td>
            }
            @if (moreDetails.doubleAnim) {
              <td class="double-animation double-animation-row fw-bold"
                >{{ getRefunds(totals, 'doubleanim') }}
              </td>
            }
            @if (moreDetails.doubleAnim) {
              <td class="double-animation double-animation-row fw-bold"
                >{{ getChargebacks(totals, 'doubleanim') }}
              </td>
            }
          }
          @if (hasGoalType('auto')) {
            @if (moreDetails.auto) {
              <td class="fid-auto fid-auto-row fw-bold">{{ getCheckouts(totals, 'auto') }}</td>
            }
            <td class="fid-auto fid-auto-row fw-bold">{{ getSales(totals, 'auto') }}</td>
            <td class="fid-auto fid-auto-row fw-bold">{{ getTurnover(totals, 'auto') | money }}</td>
            @if (moreDetails.auto) {
              <td class="fid-auto fid-auto-row fw-bold"
                >{{ getSubscriptions(totals, 'auto') }}
              </td>
            }
            @if (moreDetails.auto) {
              <td class="fid-auto fid-auto-row fw-bold"
                >{{ getRenewals(totals, 'auto') }}
              </td>
            }
            @if (moreDetails.auto) {
              <td class="fid-auto fid-auto-row fw-bold"
                >{{ getRefunds(totals, 'auto') }}
              </td>
            }
            @if (moreDetails.auto) {
              <td class="fid-auto fid-auto-row fw-bold"
                >{{ getChargebacks(totals, 'auto') }}
              </td>
            }
          }
          @if (hasGoalType('loyalty')) {
            @if (moreDetails.loyalty) {
              <td class="fid-manuelle fid-manuelle-row fw-bold"
                >{{ getCheckouts(totals, 'loyalty') }}
              </td>
            }
            <td class="fid-manuelle fid-manuelle-row fw-bold">{{ getSales(totals, 'loyalty') }}</td>
            <td class="fid-manuelle fid-manuelle-row fw-bold">{{ getTurnover(totals, 'loyalty') | money }}</td>
            @if (moreDetails.loyalty) {
              <td class="fid-manuelle fid-manuelle-row fw-bold"
                >{{ getSubscriptions(totals, 'loyalty') }}
              </td>
            }
            @if (moreDetails.loyalty) {
              <td class="fid-manuelle fid-manuelle-row fw-bold"
                >{{ getRenewals(totals, 'loyalty') }}
              </td>
            }
            @if (moreDetails.loyalty) {
              <td class="fid-manuelle fid-manuelle-row fw-bold"
                >{{ getRefunds(totals, 'loyalty') }}
              </td>
            }
            @if (moreDetails.loyalty) {
              <td class="fid-manuelle fid-manuelle-row fw-bold"
                >{{ getChargebacks(totals, 'loyalty') }}
              </td>
            }
          }
          @if (hasGoalType('opar')) {
            @if (moreDetails.opar) {
              <td class="opar opar-row fw-bold">{{ getCheckouts(totals, 'opar') }}</td>
            }
            <td class="opar opar-row fw-bold">{{ getSales(totals, 'opar') }}</td>
            <td class="opar opar-row fw-bold">{{ getTurnover(totals, 'opar') | money }}</td>
            @if (moreDetails.opar) {
              <td class="opar opar-row fw-bold"
                >{{ getSubscriptions(totals, 'opar') }}
              </td>
            }
            @if (moreDetails.opar) {
              <td class="opar opar-row fw-bold">{{ getRenewals(totals, 'opar') }}
              </td>
            }
            @if (moreDetails.opar) {
              <td class="opar opar-row fw-bold">{{ getRefunds(totals, 'opar') }}</td>
            }
            @if (moreDetails.opar) {
              <td class="opar opar-row fw-bold"
                >{{ getChargebacks(totals, 'opar') }}
              </td>
            }
          }
          @if (hasGoalType('misc')) {
            @if (moreDetails.misc) {
              <td class="misc misc-row fw-bold">{{ getCheckouts(totals, 'misc') }}</td>
            }
            <td class="misc misc-row fw-bold">{{ getSales(totals, 'misc') }}</td>
            <td class="misc misc-row fw-bold">{{ getTurnover(totals, 'misc') | money }}</td>
            @if (moreDetails.misc) {
              <td class="misc misc-row fw-bold"
                >{{ getSubscriptions(totals, 'misc') }}
              </td>
            }
            @if (moreDetails.misc) {
              <td class="misc misc-row fw-bold">{{ getRenewals(totals, 'misc') }}
              </td>
            }
            @if (moreDetails.misc) {
              <td class="misc misc-row fw-bold">{{ getRefunds(totals, 'misc') }}</td>
            }
            @if (moreDetails.misc) {
              <td class="misc misc-row fw-bold"
                >{{ getChargebacks(totals, 'misc') }}
              </td>
            }
          }
          @if (moreDetails.total) {
            <td class="total total-row fw-bold">{{ getCheckouts(totals, 'totals') }}</td>
          }
          <td class="total total-row fw-bold">{{ getSales(totals, 'totals') }}</td>
          <td class="total total-row fw-bold">{{ getTurnover(totals, 'totals') | money }}</td>
          @if (moreDetails.total) {
            <td class="total total-row fw-bold"
              >{{ getSubscriptions(totals, 'totals') }}
            </td>
          }
          @if (moreDetails.total) {
            <td class="total total-row fw-bold">{{ getRenewals(totals, 'totals') }}
            </td>
          }
          @if (moreDetails.total) {
            <td class="total total-row fw-bold">{{ getRefunds(totals, 'totals') }}
            </td>
          }
          @if (moreDetails.total) {
            <td class="total total-row fw-bold"
              >{{ getChargebacks(totals, 'totals') }}
            </td>
          }
        </tr>
      </tbody>
    </table>
    @if (loader.getDuration()) {
      <span class="duration">Report generated in {{ loader.getDuration() }} sec</span>
    }
  </div>
</div>
</div>
}
